<template>
  <b-container fluid>
    <b-row>
        <b-col lg="12" sm="12"><br>
          <b-overlay :show="loading">
            <iq-card v-show="ItemShow">
              <template>
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset">
                    <iq-card>
                        <template v-slot:body>
                            <b-row>
                                <!-- Registration Id Type -->
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Registration Id Type" vid="registration_id_type" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="5"
                                            label-for="registration_id_type"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('assitive_device_management.registration_id_type')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                plain
                                                v-model="search.registration_id_type"
                                                id="registration_id_type"
                                                :options="registrationIdTypeList"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <!-- Show if Registration Id selected as application ID  -->
                                <b-col lg="6" md="6" sm="6" xs="6" v-if="selectedRegistrationIdType === 1">
                                    <ValidationProvider name="Registration Id" vid="registration_id" rules=''>
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="5"
                                        label-for="registration_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('child_admission_management.registration_id')}}
                                        </template>
                                        <b-form-input
                                            id="registration_id"
                                            v-model="search.registration_id"
                                            v-on:blur="loadPatientDetails()"
                                            :state="errors[0] ? false : (noDataFound? false: (valid ? true : null))"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <span v-if="noDataFound" class="alert-danger">Invalid Input</span>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <!-- Show if NID selected as application ID  -->
                                <b-col lg="6" md="6" sm="6" xs="6" v-if="selectedRegistrationIdType === 2">
                                    <ValidationProvider name="NID" vid="nid" rules=''>
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="nid"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('production_service_config.nid')}}
                                        </template>
                                        <b-form-input
                                            id="nid"
                                            v-model="search.nid"
                                            v-on:blur="loadPatientDetails()"
                                            :state="errors[0] ? false : (noDataFound? false: (valid ? true : null))"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <span v-if="noDataFound" class="alert-danger">Invalid Input</span>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <!-- Show if Birth ID selected as application ID  -->
                                <b-col lg="6" md="6" sm="6" xs="6" v-if="selectedRegistrationIdType === 3">
                                    <ValidationProvider name="Birth ID" vid="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="birth_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.birth_id')}}
                                        </template>
                                        <b-form-input
                                            id="birth_id"
                                            v-model="search.birth_id"
                                            v-on:blur="loadPatientDetails()"
                                            :state="errors[0] ? false : (noDataFound? false: (valid ? true : null))"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <span v-if="noDataFound" class="alert-danger">Invalid Input</span>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <!-- Show if DSS ID selected as application ID  -->
                                <b-col lg="6" md="6" sm="6" xs="6" v-if="selectedRegistrationIdType === 4">
                                    <ValidationProvider name="DSS ID" vid="dss_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="dss_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.dss_id')}}
                                        </template>
                                        <b-form-input
                                            id="dss_id"
                                            v-model="search.dss_id"
                                            v-on:blur="loadPatientDetails()"
                                            :state="errors[0] ? false : (noDataFound? false: (valid ? true : null))"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <span v-if="noDataFound" class="alert-danger">Invalid Input</span>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                    <!-- patient informations start -->
                    <iq-card>
                        <template v-slot:headerTitle>
                            <h4 class="card-title">{{ $t('assitive_device_management.patient_information') }}</h4>
                        </template>
                        <!-- patient personal informations start -->
                        <template v-slot:body>
                            <b-row class="p-2">
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Name (En)" vid="name" rules='required'>
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="name"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{ $t('externalUser.name_en')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                id="name"
                                                v-model="profile.name"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Name (Bn)" vid="name_bn" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="name_bn"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('externalUser.name_bn')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                id="name_bn"
                                                v-model="profile.name_bn"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Father Name (En)" vid="father_name" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="father_name"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                            {{$t('externalUser.father_name_en')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                            id="father_name"
                                            v-model="profile.father_name"
                                            :disabled="true"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Father Name (Bn)" vid="father_name_bn" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="father_name_bn"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                            {{$t('externalUser.father_name_bn')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                id="father_name_bn"
                                                v-model="profile.father_name_bn"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Mother Name (En)" vid="mother_name" rules="">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="mother_name"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                            {{$t('externalUser.mother_name_en')}}
                                            </template>
                                            <b-form-input
                                                id="mother_name"
                                                v-model="profile.mother_name"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Mother Name (Bn)" vid="mother_name_bn">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="mother_name_bn"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('externalUser.mother_name_bn')}}
                                            </template>
                                            <b-form-input
                                                id="mother_name_bn"
                                                v-model="profile.mother_name_bn"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Date of Birth" vid="birth_date" rules="required">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="birth_date"
                                            slot-scope="{ valid, errors }"
                                        >
                                            <template v-slot:label>
                                                {{$t('globalTrans.date_of_birth')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-input
                                                class="date-picker"
                                                id="birth_date"
                                                v-model="profile.birth_date"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            ></b-form-input>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Gender" vid="gender" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="gender"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('globalTrans.gender')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                plain
                                                v-model="profile.gender"
                                                id="gender"
                                                :options="genderList"
                                                :disabled="true"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                                {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="NID" vid="nid" rules=''>
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="nid"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('production_service_config.nid')}}
                                        </template>
                                        <b-form-input
                                            id="nid"
                                            v-model="profile.nid"
                                            :disabled="true"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Birth ID" vid="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="birth_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.birth_id')}}
                                        </template>
                                        <b-form-input
                                            id="birth_id"
                                            v-model="profile.birth_id"
                                            :disabled="true"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="DSS ID" vid="dss_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="dss_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.dss_id')}}
                                        </template>
                                        <b-form-input
                                            id="dss_id"
                                            v-model="profile.dss_id"
                                            :disabled="true"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Mobile No" vid="mobile" rules='required'>
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="mobile"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('externalUser.mobile_no')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            id="mobile"
                                            v-model="profile.mobile"
                                            :disabled="true"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                        <!-- patient personal informations end -->
                    </iq-card>
                    <!-- patient informations end -->
                    <!-- Canter Informations -->
                    <iq-card>
                        <template v-slot:body>
                            <b-row>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Area type" vid="area_type_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="area_type_id "
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.area_type_id"
                                            id="area_type_id"
                                            :options="getAreaTypeList"
                                            @change="getAreaTypeData(profile.area_type_id)"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="division_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{$t('org_pro_division.division')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                                plain
                                                v-model="profile.division_id"
                                                :options="divisionList"
                                                id="division_id"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="district_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{$t('org_pro_district.district')}} <span class="text-danger">*</span>
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.district_id"
                                            :options="districtList"
                                            id="district_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col v-show="PauroshobaItemShow || UnionItemShow" lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Upazila" vid="upazilla_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="upazilla_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_upazilla.upazilla')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.upazilla_id"
                                            :options="upazilaList"
                                            id="upazilla_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col v-show="UnionItemShow" lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Union" vid="union_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="union_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                            {{ $t('org_pro_union.union')}}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.union_id"
                                            :options="unionList"
                                            id="union_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col v-show="CityCorpItemShow" lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="City Corporation" vid="city_corporation_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="city_corporation_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.city_corporation') }}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.city_corporation_id"
                                            :options="cityCorporationList"
                                            id="city_corporation_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col v-show="PauroshobaItemShow" lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Municipality" vid="pauroshoba_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="pauroshoba_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.pauroshoba') }}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.pauroshoba_id"
                                            :options="pauroshobaList"
                                            id="pauroshoba_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col v-show="ItemShow" lg="6" md="6" sm="6" xs="12">
                                    <ValidationProvider name="Ward" vid="ward_id">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="ward_id"
                                            slot-scope="{ valid, errors }"
                                            >
                                            <template v-slot:label>
                                                {{ $t('org_pro.ward') }}
                                            </template>
                                            <b-form-select
                                            plain
                                            v-model="profile.ward_id"
                                            :options="wardList"
                                            id="ward_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                            </b-form-select>
                                            <div class="invalid-feedback">
                                            {{ errors[0] }}
                                            </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="6" md="6" sm="6" xs="12">
                                <ValidationProvider name="Center" vid="center_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="center_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('externalUser.center')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                            plain
                                            v-model="profile.center_id"
                                            id="center_id"
                                            :options="centerList"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                                </b-col>
                            </b-row>
                        </template>
                    </iq-card>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{$t('globalTrans.submit')}}</b-button>
                        </div>
                    </div>
                  </b-form>
                </ValidationObserver>
              </template>
            </iq-card>
            <iq-card v-show="MessageShow">
              <div v-if="requestPregress === 1" class="alert alert-danger text-center" style="flex-direction: column;"> A request is already pending! </div>
              <div v-if="requestPregress === 2" class="alert alert-success text-center" style="flex-direction: column;"> A request is already in progress. </div>
            </iq-card>
          </b-overlay>
        </b-col>
      </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { getPatientDetailsApi } from '../../../assistive-device-management/api/routes'
import { submitCenterChangeRequest } from '../../api/routes'
import custom from '@/store/custom'
import { EventBus } from '@/EventBusLayout'
// import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data () {
      return {
        noDataFound: false,
        ItemShow: true,
        MessageShow: false,
        requestPregress: 0,
        CityCorpItemShow: false,
        PauroshobaItemShow: false,
        UnionItemShow: false,
        selectedRegistrationIdType: 1,
        search: {
            application_type: 1,
            registration_id_type: 1,
            registration_id: '',
            nid: '',
            birth_id: '',
            dss_id: ''
        },
        profile: {
            application_type: 1,
            application_id: 1,
            patient_id: '',
            name: '',
            name_bn: '',
            father_name: '',
            father_name_bn: '',
            mother_name: '',
            mother_name_bn: '',
            nid: '',
            birth_id: '',
            dss_id: '',
            contact_no: '',
            gender: 0,
            disability_type_id: 0,
            assistive_device_id: 0,
            birth_date: '',
            area_type_id: 0,
            city_corporation_id: 0,
            pauroshoba_id: 0,
            division_id: 0,
            district_id: 0,
            upazilla_id: 0,
            union_id: 0,
            ward_id: 0,
            center_id: 0
        },
        districtList: [],
        upazilaList: [],
        unionList: [],
        cityCorporationList: [],
        pauroshobaList: [],
        wardList: [],
        centerList: [],
        activeCenter: {
            area_type_id: 0,
            division_id: 0,
            district_id: 0,
            upazilla_id: 0,
            union_id: 0,
            city_corporation_id: 0,
            ward_id: 0,
            pauroshoba_id: 0,
            value: 0
        }
      }
    },
    created () {
    //   this.getPreviousRequestData()
        if (this.$store.state.dataFilters.officeId) {
            const centerOfficeId = this.$store.state.dataFilters.officeId
            this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
            this.profile = Object.assign({}, this.profile, {
                area_type_id: this.activeCenter.area_type_id,
                division_id: this.activeCenter.division_id,
                district_id: this.activeCenter.district_id,
                upazila_id: this.activeCenter.upazilla_id,
                union_id: this.activeCenter.union_id,
                ward_id: this.activeCenter.ward_id,
                city_corporation_id: this.activeCenter.city_corporation_id,
                pauroshoba_id: this.activeCenter.pauroshoba_id,
                center_id: this.activeCenter.value
            })
            this.getAreaTypeData(this.activeCenter.area_type_id)
        }
    },
    mounted () {
    },
    watch: {
        'search.registration_id_type': function (newVal, oldVal) {
            this.noDataFound = false
            this.resetPatientSearch()
            this.resetPatientinformations()
            this.selectedRegistrationIdType = newVal
        },
      'profile.division_id': function (newVal, oldVal) {
        this.districtList = this.getDistrictList(newVal)
        this.centerList = this.getCenterByDivision(newVal)
        if (!this.activeCenter.value) {
            this.profile.center_id = 0
        }
        if (!this.activeCenter.district_id) {
            this.profile.district_id = 0
        }
      },
      'profile.district_id': function (newVal, oldVal) {
        this.preWardList = []
        if (!this.activeCenter.ward_id) {
            this.profile.ward_id = 0
        }
        this.cityCorporationList = this.getCityCorporationList(newVal)
        this.upazilaList = this.getUpazilaList(newVal)
        this.centerList = this.getCenterByDistrict(newVal)
        if (!this.activeCenter.value) {
            this.profile.center_id = 0
        }
        if (!this.activeCenter.city_corporation_id) {
            this.profile.city_corporation_id = 0
        }
        if (!this.activeCenter.upazilla_id) {
            this.profile.upazilla_id = 0
        }
      },
      'profile.upazilla_id': function (newVal, oldVal) {
          this.WardList = []
          if (!this.activeCenter.ward_id) {
            this.profile.ward_id = 0
          }
        if (parseInt(newVal) !== parseInt(oldVal)) {
          if (parseInt(newVal) !== 0) {
            this.unionList = this.getUnionList(newVal)
            this.pauroshobaList = this.getPauroshobaList(newVal)
            // this.centerList = this.getCenterByUpazilla(newVal)
            if (!this.activeCenter.value) {
                this.profile.center_id = 0
            }
            if (!this.activeCenter.union_id) {
                this.profile.union_id = 0
            }
            if (!this.activeCenter.pauroshoba_id) {
                this.profile.pauroshoba_id = 0
            }
          } else {
            if (this.profile.district_id !== 0) {
              this.centerList = this.getCenterByDistrict(this.profile.district_id)
              if (!this.activeCenter.value) {
                this.profile.center_id = 0
              }
            }
          }
        }
      },
      'profile.city_corporation_id': function (newVal, oldVal) {
        if (newVal !== oldVal && !this.profile.paurasabha_id && !this.profile.union_id) {
            this.wardList = this.getWardListByCityCorportaion(newVal)
            // this.centerList = this.getCenterByCityCorp(newVal)
            if (!this.activeCenter.value) {
                this.profile.center_id = 0
            }
            if (!this.activeCenter.ward_id) {
                this.profile.ward_id = 0
            }
        }
      },
      'profile.pauroshoba_id': function (newVal, oldVal) {
        if (newVal !== oldVal && !this.profile.city_corporation_id && !this.profile.union_id) {
            this.wardList = this.getWardListByPauroshoba(newVal)
            // this.centerList = this.getCenterByPoura(newVal)
            if (!this.activeCenter.value) {
                this.profile.center_id = 0
            }
            if (!this.activeCenter.ward_id) {
                this.profile.ward_id = 0
            }
        }
      },
      'profile.union_id': function (newVal, oldVal) {
        if (newVal !== oldVal && !this.profile.pauroshoba_id && !this.profile.city_corporation_id) {
            this.wardList = this.getWardListByUnion(newVal)
            // this.centerList = this.getCenterByUnion(newVal)
            if (!this.activeCenter.value) {
                this.profile.center_id = 0
            }
            if (!this.activeCenter.ward_id) {
                this.profile.ward_id = 0
            }
        }
      }
    //   'profile.ward_id': function (newVal, oldVal) {
    //     if (parseInt(newVal) !== parseInt(oldVal)) {
    //         if (parseInt(newVal) !== 0) {
    //         //   this.centerList = this.getCenterByUnion(newVal)
    //           this.profile.center_id = 0
    //         } else {
    //           if (this.profile.area_type_id !== 0) {
    //             const typeId = this.profile.area_type_id
    //             if (typeId === 1) {
    //                 this.centerList = this.getCenterByCityCorp(this.profile.city_corporation_id)
    //                 this.profile.center_id = 0
    //             } else if (typeId === 2) {
    //                 this.centerList = this.getCenterByPoura(this.profile.pauroshoba_id)
    //                 this.profile.center_id = 0
    //             } else if (typeId === 3) {
    //                 this.centerList = this.getCenterByUnion(this.profile.union_id)
    //                 this.profile.center_id = 0
    //             }
    //           }
    //         }
    //     }
    //   }
    },
    computed: {
        loading () {
            return this.$store.state.AwarenessEventService.static.loading
        },
        registrationIdTypeList: function () {
            const objectData = custom.registrationIdType
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getAreaTypeList: function () {
            const objectData = custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        genderList: function () {
            return this.$store.state.AwarenessEventService.commonObj.genderList
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        idscCenterList: function () {
            return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        }
    },
    methods: {
        resetPatientSearch () {
            Object.assign(this.search,
                { registration_id: '' },
                { nid: '' },
                { birth_id: '' },
                { dss_id: '' }
            )
        },
        resetPatientinformations () {
            Object.assign(this.profile,
                { id: '' },
                { name: '' },
                { name_bn: '' },
                { father_name: '' },
                { father_name_bn: '' },
                { mother_name: '' },
                { mother_name_bn: '' },
                { birth_date: '' },
                { gender: 0 },
                { nid: '' },
                { birth_id: '' },
                { dss_id: '' },
                { contact_no: '' },
                { pre_area_type_id: 0 },
                { pre_city_corporation_id: 0 },
                { pre_pauroshoba_id: 0 },
                { pre_division_id: 0 },
                { pre_district_id: 0 },
                { pre_upazilla_id: 0 },
                { pre_union_id: 0 },
                { pre_ward_id: 0 },
                { pre_post_code: '' },
                { pre_post_office: '' },
                { pre_address_en: '' },
                { pre_address_bn: '' },
                { per_area_type_id: 0 },
                { per_city_corporation_id: 0 },
                { per_pauroshoba_id: 0 },
                { per_division_id: 0 },
                { per_district_id: 0 },
                { per_upazilla_id: 0 },
                { per_union_id: 0 },
                { per_ward_id: 0 },
                { per_post_code: '' },
                { per_post_office: '' },
                { per_address_en: '' },
                { per_address_bn: '' }
            )
        },
        async loadPatientDetails () {
            this.$store.dispatch('AwarenessEventService/mutateFormLoad', { loading: true })
            const params = Object.assign({}, this.search)
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, getPatientDetailsApi, params)
            this.$store.dispatch('AwarenessEventService/mutateFormLoad', { loading: false })
            if (result.success) {
                this.noDataFound = false
                Object.assign(this.profile,
                    { patient_id: result.data.patient_id },
                    { application_id: result.data.application_id },
                    { name: result.data.name },
                    { name_bn: result.data.name_bn },
                    { contact_no: result.data.mobile },
                    { father_name: result.data.father_name },
                    { father_name_bn: result.data.father_name_bn },
                    { mother_name: result.data.mother_name },
                    { mother_name_bn: result.data.mother_name_bn },
                    { birth_date: result.data.birth_date },
                    { gender: result.data.gender },
                    { nid: result.data.nid },
                    { birth_id: result.data.birth_id },
                    { dss_id: result.data.dss_id },
                    { mobile: result.data.mobile }
                )
            } else {
                this.noDataFound = true
                this.resetPatientinformations()
            }
        },
        getAreaTypeData (typeId) {
          this.ItemShow = true
          if (typeId === 1) {
            this.CityCorpItemShow = true
            this.PauroshobaItemShow = false
            this.UnionItemShow = false
            if (!this.activeCenter.pauroshoba_id) {
                this.profile.paurasabha_id = 0
            }
            if (!this.activeCenter.union_id) {
                this.profile.union_id = 0
            }
            if (!this.activeCenter.ward_id) {
                this.profile.ward_id = 0
            }
          } else if (typeId === 2) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = true
            this.UnionItemShow = false
            this.profile.city_corporation_id = 0
            this.profile.union_id = 0
            this.profile.ward_id = 0
          } else if (typeId === 3) {
            this.CityCorpItemShow = false
            this.PauroshobaItemShow = false
            this.UnionItemShow = true
            this.profile.city_corporation_id = 0
            this.profile.paurasabha_id = 0
            this.profile.ward_id = 0
          }
        },
        async createData () {
          this.$store.dispatch('AwarenessEventService/mutateFormLoad', { loading: true })
        //   this.getPreviousRequestData()
          let result = null
          const config = {
              headers: { 'content-type': 'multipart/form-data' }
          }
          var formData = new FormData()
          Object.keys(this.profile).map(key => {
            formData.append(key, this.profile[key])
          })
          if (this.profile.patient_id) {
            //   formData.append('_method', 'POST')
              result = await RestApi.postData(awarenessEventServiceBaseUrl, submitCenterChangeRequest, formData, config)
          }
          this.$store.dispatch('AwarenessEventService/mutateFormLoad', { loading: false })
          if (result.success) {
              EventBus.$emit('DEALER_RETAILER_MENU_UPDATE')
              if (result.notification && this.$store.state.emitNotification) {
                this.$socket.emit('send-notification', result.notification)
              }
              this.$toast.success({
                  title: 'Success',
                  message: this.id ? this.$t('globalTrans.save_msg') : 'Data Created Successfully!',
                  color: '#D6E09B'
              })
              this.$bvModal.hide('modal-7')
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
          } else {
              this.$refs.form.setErrors(result.errors)
          }
        },
        getDistrictList (divisionId = null) {
          const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

          if (divisionId) {
              return districtList.filter(district => district.division_id === divisionId)
          }

          return districtList
        },
        getUpazilaList (districtId = null) {
          const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

          if (districtId) {
              return upazilaList.filter(upazila => upazila.district_id === districtId)
          }

          return upazilaList
        },
        getUnionList (upazilaId = null) {
          const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
          if (upazilaId) {
              return unionList.filter(union => union.upazilla_id === upazilaId)
          }

          return unionList
        },
        getCityCorporationList (districtId) {
          const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
        },
        getPauroshobaList (upazillaId = null) {
          const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
          if (upazillaId) {
              return objectData.map((obj, key) => {
                  if (this.$i18n.locale === 'bn') {
                      return { value: obj.value, text: obj.text_bn }
                  } else {
                      return { value: obj.value, text: obj.text_en }
                  }
              })
          }
        },
        getWardListByCityCorportaion (cityCorpId) {
          const objectData = this.$store.state.commonObj.wardList
          const wardObjectList = objectData.filter(item => item.city_corporation_id === parseInt(cityCorpId) && item.status === 0)
          return wardObjectList.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
        },
        getWardListByPauroshoba (pauroshobaId) {
          const objectData = this.$store.state.commonObj.wardList
          const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
          return wardObjectList.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text }
              }
          })
        },
        getWardListByUnion (unionId) {
          const objectData = this.$store.state.commonObj.wardList
          const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
          return wardObjectList.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text }
              }
          })
        },
        getCenterByDivision (divisionId) {
          const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
          const centerObjectList = objectData.filter(item => item.division_id === divisionId)
          return centerObjectList.map((obj, key) => {
              return { value: obj.value, text: obj.text }
          })
        },
        getCenterByDistrict (districtId) {
          if (districtId) {
            const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
            const centerObjectList = objectData.filter(item => item.district_id === districtId)
            return centerObjectList.map((obj, key) => {
                return { value: obj.value, text: obj.text }
            })
          }
        }
        // getCenterByCityCorp (CityCorptId) {
        //   if (CityCorptId) {
        //     const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        //     const centerObjectList = objectData.filter(item => item.city_corporation_id === CityCorptId)
        //     return centerObjectList.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text }
        //         }
        //     })
        //   }
        // },
        // getCenterByUpazilla (UpazillaId) {
        //   if (UpazillaId) {
        //     const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        //     const centerObjectList = objectData.filter(item => item.upazilla_id === UpazillaId)
        //     return centerObjectList.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text }
        //         }
        //     })
        //   }
        // },
        // getCenterByUnion (UnionId) {
        //   if (UnionId) {
        //     const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        //     const centerObjectList = objectData.filter(item => item.union_id === UnionId)
        //     return centerObjectList.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text }
        //         }
        //     })
        //   }
        // },
        // getCenterByPoura (PouraId) {
        //   if (PouraId) {
        //     const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        //     const centerObjectList = objectData.filter(item => item.pauroshoba_id === PouraId)
        //     return centerObjectList.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text }
        //         }
        //     })
        //   }
        // },
        // getCenterByWard (WardId) {
        //   if (WardId) {
        //     const objectData = this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        //     const centerObjectList = objectData.filter(item => item.ward_id === WardId)
        //     return centerObjectList.map((obj, key) => {
        //         if (this.$i18n.locale === 'bn') {
        //             return { value: obj.value, text: obj.text_bn }
        //         } else {
        //             return { value: obj.value, text: obj.text }
        //         }
        //     })
        //   }
        // }
    }
}
</script>
